export default ({ capyCast, onChoice }) => {
  return (
    <div style={{
      display: "grid",
      gridTemplateColumns: `repeat(auto-fit, minmax(90px, 1fr))`,
      gap: `1rem`,
      marginBottom: '1rem'
    }}>
      {
        capyCast.map(move => (
          <a onClick={() => { onChoice(move) }} key={move.id} >
            {move.name} 
            <img src={`gifs/${move.slug}.gif`} alt={move.name} />
          </a>
        ))
      }
    </div>
  )
}